export type LlmBillingMode = 'credits' | 'byok'

export interface MafiaLlmProviderSettings {
  mode: LlmBillingMode
  /** OpenAI-compatible base URL, e.g. https://api.openai.com/v1 */
  baseUrl: string
  apiKey: string
  model: string
}

export const DEFAULT_LLM_SETTINGS: MafiaLlmProviderSettings = {
  mode: 'credits',
  baseUrl: '',
  apiKey: '',
  model: 'gpt-4o-mini',
}

const STORAGE_KEY = 'mafia-llm-provider'

export function loadLlmProviderSettings(): MafiaLlmProviderSettings {
  if (typeof window === 'undefined') return { ...DEFAULT_LLM_SETTINGS }
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return { ...DEFAULT_LLM_SETTINGS }
    const parsed = JSON.parse(raw) as Partial<MafiaLlmProviderSettings>
    return {
      ...DEFAULT_LLM_SETTINGS,
      ...parsed,
      mode: parsed.mode === 'byok' ? 'byok' : 'credits',
    }
  } catch {
    return { ...DEFAULT_LLM_SETTINGS }
  }
}

export function saveLlmProviderSettings(settings: MafiaLlmProviderSettings) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(settings))
}

export interface MafiaLlmProviderPayload {
  mode: LlmBillingMode
  baseUrl?: string
  apiKey?: string
  model?: string
}

/** Payload sent with game actions — key stays in browser until request time. */
export function toLlmProviderPayload(
  settings: MafiaLlmProviderSettings
): MafiaLlmProviderPayload {
  if (settings.mode !== 'byok') {
    return { mode: 'credits' }
  }
  if (!settings.baseUrl.trim() || !settings.apiKey.trim() || !settings.model.trim()) {
    return { mode: 'credits' }
  }
  return {
    mode: 'byok',
    baseUrl: settings.baseUrl.trim().replace(/\/+$/, ''),
    apiKey: settings.apiKey.trim(),
    model: settings.model.trim(),
  }
}
